const dnd = {
  namespaced: true,
  state: {
    type: null,
    item: null
  },
  mutations: {
    updateItem(state, item) {
      state.item = item;
    },
    updateType(state, type) {
      state.type = type;
    },
  },
  actions: {
    update({ commit }, { type, item }) {
      commit('updateItem', item);
      commit('updateType', type);
    }
  }
}
export default dnd;
